import type { AnalyticEvent } from '@bosca/analytics-client-browser'
import { addSink, AnalyticEventSink, BoscaSink, logImpression } from '@bosca/analytics-client-browser'

export default defineNuxtPlugin(async () => {
    if (typeof window === 'undefined') return {}

    const router = useRouter()
    try {
        addSink(new GtagAnalyticsSink())

        if (process.env.NODE_ENV === 'production') {
            addSink(new BoscaSink('', 'com.passionequip', '0.0.1', 'passionequip'))
        }

        router.afterEach((to) => {
            nextTick(() => {
                logImpression({
                    id: to.fullPath,
                    type: 'page',
                    extras: {},
                    content: [],
                })
            })
        })

        return {}
    }
    catch (e) {
        console.error('failed to initialize firebase analytics', e)
        if (process.env.NODE_ENV === 'production') {
            addSink(new BoscaSink('', 'com.passionequip', '0.0.1', 'passionequip'))
        }
        return {}
    }
})

export class GtagAnalyticsSink extends AnalyticEventSink {
    async onAdd(event: AnalyticEvent): Promise<void> {
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const gtag = window.gAppGtag
            if (event.element.type === 'page' && (!event.element.extras || !event.element.extras.scrolling)) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                gtag('event', 'custom_screen_view', {
                    firebase_screen: event.element.id,
                    firebase_screen_class: 'page',
                    ...event.toParameters(),
                })
            } else {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                gtag('event', event.name, event.toParameters())
            }
        } catch (e: any) {
            console.error('failed to log event', e)
        }
    }
}